document.documentElement.classList.remove('no-js');
document.addEventListener('click',function(e){
  const toggle=e.target.closest('[data-mobile-toggle]');
  if(toggle){const nav=document.querySelector('[data-mobile-nav]'); if(nav) nav.classList.toggle('is-open');}
  const thumb=e.target.closest('[data-gallery-src]');
  if(thumb){const main=document.querySelector('[data-gallery-main]');if(main){main.src=thumb.dataset.gallerySrc;main.alt=thumb.dataset.galleryAlt||'';}}
  const q=e.target.closest('[data-qty]');
  if(q){const wrap=q.closest('.qty');const input=wrap&&wrap.querySelector('input');if(!input)return;let v=parseInt(input.value||'1',10);v=q.dataset.qty==='plus'?v+1:Math.max(1,v-1);input.value=v;}
});

(function(){
  const center = document.querySelector('[data-legal-center]');
  if(!center) return;
  const panels = Array.from(center.querySelectorAll('[data-legal-panel]'));
  const navLinks = Array.from(center.querySelectorAll('[data-legal-link]'));
  let lastFocus = null;

  function keyFromHash(hash){
    const m=(hash||'').match(/^#legal-(shipping-policy|refund-policy|privacy-policy|terms-of-service|payment-policy|contact|about-us)$/);
    return m ? m[1] : null;
  }
  function openLegal(key, updateHash=true){
    if(!key) return;
    lastFocus=document.activeElement;
    panels.forEach(p=>p.hidden=p.dataset.legalPanel!==key);
    navLinks.forEach(a=>a.classList.toggle('is-active',a.dataset.legalLink===key));
    center.hidden=false;
    center.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('legal-open');
    const content=center.querySelector('.legal-center__content'); if(content) content.scrollTop=0;
    if(updateHash && location.hash !== '#legal-'+key) history.pushState(null,'','#legal-'+key);
    const close=center.querySelector('[data-legal-close].legal-center__close'); if(close) close.focus({preventScroll:true});
  }
  function closeLegal(clearHash=true){
    center.hidden=true;
    center.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('legal-open');
    if(clearHash && keyFromHash(location.hash)) history.pushState(null,'',location.pathname+location.search);
    if(lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
  }

  document.addEventListener('click',function(e){
    const link=e.target.closest('[data-legal-link]');
    if(link){ e.preventDefault(); openLegal(link.dataset.legalLink,true); return; }
    if(e.target.closest('[data-legal-close]')){ e.preventDefault(); closeLegal(true); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !center.hidden) closeLegal(true); });
  window.addEventListener('hashchange',function(){ const key=keyFromHash(location.hash); if(key) openLegal(key,false); else if(!center.hidden) closeLegal(false); });

  // Old links from earlier theme versions should never strand a visitor on 404.
  const legacy={
    '/pages/shipping-policy':'shipping-policy','/pages/refund-policy':'refund-policy','/pages/privacy-policy':'privacy-policy',
    '/pages/terms-of-service':'terms-of-service','/pages/payment-policy':'payment-policy','/pages/contact':'contact','/pages/about-us':'about-us'
  };
  if(document.body.classList.contains('template-404') && legacy[location.pathname]){
    location.replace('/#legal-'+legacy[location.pathname]); return;
  }
  const initial=keyFromHash(location.hash); if(initial) openLegal(initial,false);
})();
